import pLogo from 'assets/images/p-logo.svg';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ExpandIcon from '../../../components/common/ExpandIcon';
import applyMask from '../../../utils/asteriskMask';
import { setCurrentBet as dispatchSetCurrentBet } from '../actions';
import { setCurrentBet as setCurrentBetForWebAnalytics } from '../../../modules/analytics/actions';
import { getCurrentBetId, getOpenBet, getSingleSelectionLabel } from '../selectors';

export const BetListItem = ({
  currentBetId,
  bet,
  setCurrentBet,
  setCurrentBetForAnalytics,
  selectionLabel
}) => {
  const handleClick = (betId) => {
    setCurrentBet(betId);
    const { isoBetPlacedTime, betStake, betType } = bet;
    setCurrentBetForAnalytics({
      betPlacedTime: isoBetPlacedTime,
      betStake,
      betType,
      selectionLabel
    });
  };
  return (
    <li
      className={classnames('open-bets-list-item', {
        'open-bets-list-item--selected': bet.betId === currentBetId
      })}
      key={bet.betId}
      onClick={() => handleClick(bet.betId)}
    >
      <div className="open-bets-list-item__select-button">
        <ExpandIcon />
      </div>
      <div className="open-bets-list-item__header">
        &pound;{bet.betStakePerLine} {bet.betType}
      </div>
      <ul className="open-bets-list-item__main">
        <li className="open-bets-list-item__field">
          <div className="open-bets-list-item__field-label">Placed</div>
          <div className="open-bets-list-item__field-value">{bet.betPlacedTime}</div>
        </li>
        <li className="open-bets-list-item__field">
          <div className="open-bets-list-item__field-label">Slip</div>
          <div className="open-bets-list-item__field-value">
            {applyMask(bet.slipId, 1, bet.slipId.length - 5)}
          </div>
        </li>
        <li className="open-bets-list-item__field">
          <div className="open-bets-list-item__field-label">Stake</div>
          <div className="open-bets-list-item__field-value">
            {
              bet.fundingType === 'PLUS' && (
                <img src={pLogo} className="open-bets-list-item__field-image" />
              )
            }&pound;{bet.betStake}
          </div>
        </li>
      </ul>
    </li>
  );
};

BetListItem.propTypes = {
  currentBetId: PropTypes.string,
  bet: PropTypes.object.isRequired,
  selectionLabel: PropTypes.string,
  setCurrentBet: PropTypes.func.isRequired,
  setCurrentBetForAnalytics: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => ({
  bet: getOpenBet(state, props),
  currentBetId: getCurrentBetId(state),
  selectionLabel: getSingleSelectionLabel(state, props),
});

const mapDispatchToProps = {
  setCurrentBet: dispatchSetCurrentBet,
  setCurrentBetForAnalytics: setCurrentBetForWebAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(BetListItem);
